import React from "react";
import Skeleton from "react-loading-skeleton";

export default function AcademyEpisodeLoading() {
  return (
    <div className="w-full bg-[#222] rounded-xl flex-col gap-3">
      <Skeleton className="block rounded-xl xl:h-[176px] h-60 sm:h-64" />
      <div className="flex flex-col gap-3 px-3 pb-3">
        <Skeleton className="block w-36 rounded-xl h-12 -mt-3" />
        <Skeleton className="block w-full rounded-xl h-5 -mt-4" />
        <Skeleton className="block w-full rounded-xl h-5 -mt-6" />

        <div className="flex w-full justify-center -mt-4">
          <Skeleton className="block w-40 rounded-xl h-5 -mb-5" />
        </div>
      </div>
    </div>
  );
}
